<template>
  <div>
    <v-dialog max-width="400" v-model="dialog">
      <v-card>
        <v-card-title class="text-h6 lighten-2">
          Archive recording
          <v-spacer></v-spacer>
          <v-icon @click="closeDialog" size="18" class="white--black">
            mdi-close
          </v-icon>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-6 text-center"
          >Are you sure you want to archive this recording
          <b>{{ recording_item.title }}</b> ?
        </v-card-text>
        <v-card-actions class="pb-10 pt-5">
          <v-spacer></v-spacer>
          <v-btn
            @click="closeDialog"
            class="grey--text capitalize px-10"
            rounded
            text
          >
            Close
          </v-btn>
          <v-btn
            @click="handleArchive(recording_item)"
            class="capitalize px-10"
            color="primary"
            rounded
            :loading="loading"
          >
            Archive recording
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "ArchiveRecordingDialog",
  props: {
    type: String,
    default: null,
  },
  data() {
    return {
      dialog: false,
      loading: false,
      recording_item: {},
    };
  },
  methods: {
    ...mapActions("recordings", ["archive_recording"]),

    async handleArchive(record) {
      this.loading = true;
      try {
        const response = await this.archive_recording(record);
        this.$store.dispatch("recordings/dashboard_my_recordings");
        this.$store.dispatch("recordings/dashboard_archived_recordings");
        this.$store.dispatch("folders/my_folders");
        this.$store.dispatch("recordings/dashboard_received_recordings");
        this.$store.dispatch(
          "recordings/dashboard_received_archived_recordings"
        );
        this.$emit("load-recordings");
        this.loading = false;
        this.$parent.toast.sendSuccess(response);
        this.closeDialog();
        if (this.$route.name == "FoldersView") {
          window.location.reload();
        }
      } catch (e) {
        this.loading = false;
        this.$parent.toast.sendError(e);
      }
    },
    openDialog(record) {
      this.recording_item = Object.assign({}, record);
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    },
  },
};
</script>

<style scoped></style>
